/* eslint-disable */
export default {
  status: 'Stato',
  acceptQueueCalls: 'Accetta chiamate in coda',
  callQueueDisabledReason:
    "Questa impostazione è gestita dall'amministratore aziendale.",
  callQueueManagement: 'Gestisci code',
} as const;

// @key: @#@"status"@#@ @source: @#@"Status"@#@
// @key: @#@"acceptQueueCalls"@#@ @source: @#@"Accept call queue calls"@#@
// @key: @#@"callQueueDisabledReason"@#@ @source: @#@"This setting is managed by your company administrator."@#@
// @key: @#@"callQueueManagement"@#@ @source: @#@"Manage queues"@#@
